import { fetchApi } from "./api";
import type { ThemeId, ThemeSettings, ThemeSettingsResponse } from "./theme.queries";

// Public: all five theme blobs + the active direction.
export const listThemeSettings = () =>
  fetchApi<ThemeSettingsResponse>("content", "listThemeSettings", {}, { auth: false });

// Admin: replace one theme's blob wholesale; make_default also points
// site_settings.active_theme at it (the editor's "Default theme" checkbox).
export const saveThemeSettings = (opts: {
  data: { theme_id: ThemeId; settings: ThemeSettings; make_default?: boolean };
}) => fetchApi<{ ok: true; active: ThemeId }>("content", "saveThemeSettings", opts.data);
